// export const state = {
//   filters: null,
//   filtersValue: null,
//   lastPath: null,
// }

// export const getters = {
//   getFiltersValue: state => currentPath => {
//     return state.lastPath === currentPath ? state.filtersValue : null
//   },
// }

// export const mutations = {
//   SET_FILTERS(state, payload) {
//     state.filters = payload.item
//     state.filtersValue = payload.value
//   },
//   SET_LASTPATH(state, payload) {
//     state.lastPath = payload
//   },
//   CLEAR_STATE(state) {
//     state.filters = null
//     state.filtersValue = null
//     state.lastPath = null
//   },
// }

export const state = {
  filters: {},
}

export const getters = {
  getFilters: state => path => {
    return state.filters[path]
  },
}

export const mutations = {
  SET_FILTERS(state, payload) {
    state.filters[payload.name] = payload.item
  },
  CLEAR_FILTERS(state, payload) {
    state.filters[payload] = null
  },
  CLEAR_STATE(state) {
    state.filters = null
    state.filtersValue = null
    state.lastPath = null
  },
}
